
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export const useEmailSuggestions = () => {
  const [emailSuggestions, setEmailSuggestions] = useState<string[]>([]);

  useEffect(() => {
    const fetchEmailSuggestions = async () => {
      try {
        const emails = new Set<string>();

        // Récupérer les emails depuis les produits existants
        const { data: products } = await supabase
          .from('products')
          .select('primary_email, secondary_emails');

        products?.forEach((product: any) => {
          if (product.primary_email) {
            emails.add(product.primary_email);
          }
          if (product.secondary_emails) {
            const secondaryList = product.secondary_emails.split(',').filter((email: string) => email.trim());
            secondaryList.forEach((email: string) => emails.add(email.trim()));
          }
        });

        // Récupérer aussi les emails des utilisateurs authentifiés depuis auth.users
        const { data: { user } } = await supabase.auth.getUser();
        if (user?.email) {
          emails.add(user.email);
        }

        // Récupérer les emails des profils utilisateurs
        const { data: userProfiles } = await supabase
          .from('user_profiles')
          .select('email');

        userProfiles?.forEach((profile) => {
          if (profile.email) {
            emails.add(profile.email);
          }
        });

        setEmailSuggestions(Array.from(emails));
      } catch (error) {
        console.error('Erreur lors de la récupération des suggestions d\'emails:', error);
      }
    };

    fetchEmailSuggestions();
  }, []);

  return emailSuggestions;
};
